// Default menu items configuration
export const DEFAULT_MENU_ITEMS = {
  heading: true,
  bold: true,
  italic: true,
  bulletList: true,
  orderedList: true,
  link: true,
  undoRedo: true
};

export const AMENITIES_MENU_ITEMS = {
  heading: false,
  bold: true,
  italic: true,
  bulletList: false,
  orderedList: false,
  link: true,
  undoRedo: true
};
